import { api, openApi } from "..";

export const AdminServices = {
  registerUser: (payload: any) =>
    api.post(`/admin/user/register/v2`, payload).then((data) => data?.data),

  fetchCategories: () =>
    api.get(`/admin/screen/categories`).then((data) => data?.data),

  fetchSubcategories: () =>
    api.get(`/admin/screen/subcategories`).then((data) => data?.data),

  registerScreen: (payload: any) =>
    api.post(`/admin/screen/register/v2`, payload).then((data) => data?.data),

  getMerchantCampaigns: (payload: any) =>
    api
      .get(`/admin/campaign/merchant/org/${payload.orgId}/page/${payload.page}`)
      .then((data) => data?.data),

  getUserByEmail: (email: string) =>
    api.get(`admin/user/email/${email}`).then((data) => data?.data),

  getUserById: (id: string) =>
    api.get(`admin/user/id/${id}`).then((data) => data?.data),

  getScreenList: (pageNumber: number | string) =>
    api
      .get(`admin/screen/state/ALL/city/ALL/page/${pageNumber}`)
      .then((data) => data?.data),

  getScreenById: (id: number | string | undefined) =>
    api.get(`public/screen/${id}`).then((data) => data?.data),

  // control hub all apis
  getUserInfo: (payload: { userIdOrEmail: string; isEmail: boolean }) => {
    const endpoint = payload.isEmail
      ? `admin/user/v2/email/${payload.userIdOrEmail}`
      : `admin/user/v2/id/${payload.userIdOrEmail}`;
    return api.get(endpoint).then((data) => data?.data);
  },
  registerUserScreen: (payload: any) =>
    api.post(`/admin/screen/register`, payload).then((data) => data?.data),

  getStoreInfo: (storeId: string) =>
    api.get(`admin/user/store/id/${storeId}`).then((data) => data?.data),

  // getMediaList: (payload: { orgId: string; status?: string; page?: number }) =>
  //   api
  //     .get(
  //       `/public/media/list/org/${payload.orgId}/status/${
  //         payload.status ?? "ALL"
  //       }/page/${payload.page ?? 0}`,
  //       {
  //         headers: {
  //           "X-Custom-ClientId": "srwjhzln12",
  //         },
  //       }
  //     )
  //     .then((data) => data?.data),

  uploadMediaFile: async (
    file: File,
    orgId: string,
    mediaType?: string,
    name?: string,
  ) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("orgId", orgId);
    if (mediaType) formData.append("mediaType", mediaType);
    if (name) formData.append("name", name);

    return openApi
      .post(`/open/media/other/upload`, formData)
      .then((res) => res?.data);
  },

  updateScreenInfo: (payload: {
    id: number;
    name: string;
    type: "TV" | "CHANNEL";
    status: string;
    resolution: "P720" | "P1080" | "K2" | "K4";
    orientation: "LANDSCAPE" | "PORTRAIT";
    merchantAdsQuota: number;
    isPublic: boolean;
    size: string;
    screenCategory?: string;
    imageUrl?: string;
    videoUrl?: string;
  }) => api.post(`/admin/screen/update`, payload).then((data) => data?.data),

  //   export const getClusterScreenList = async (payload = {}) => {
  //   const params = new URLSearchParams();

  //   params.append("states", payload.states);
  //   params.append("cities", payload.cities);
  //   params.append("page", payload.page ?? 0);
  //   if (payload.amfL) params.append("amfl", payload.amfL);
  //   if (payload.amfU) params.append("amfu", payload.amfU);
  //   if (payload.genders) params.append("genders", payload.genders);
  //   if (payload.incomeCategories) params.append("incomeCategories", payload.incomeCategories);
  //   if (payload.ageGroups) params.append("ageGroups", payload.ageGroups);
  //   if (payload.userId) params.append("userId", payload.userId);
  //   if (payload.categories) params.append("categories", payload.categories);

  //   return await api.get(`public/screen?${params.toString()}`).then((data) => data?.data);
  // };
  getScreenInfoByScreenId: (screenId: string | number) =>
    api.get(`/admin/screen/details/id/${screenId}`).then((data) => data?.data),

  getStoreInfoByStoreId: (screenId: string | number) =>
    api.get(`/public/screen/store/id/${screenId}`).then((data) => data?.data),

  getPublicScreens: (payload = {}) =>
    api.get(`/public/screen`, { params: payload }).then((data) => data?.data),

  // media new tab :
  getMediaList: (payload: {
    status?: string;
    page?: number;
    signal?: AbortSignal;
  }) =>
    api
      .get(
        `/admin/media/list/v2/status/${payload.status ?? "ALL"}/page/${payload.page ?? 0}`,
        { signal: payload.signal },
      )
      .then((data) => data?.data),

  reviewMedia: (payload: any) =>
    api.post(`/admin/media/review/v2`, payload).then((data) => data?.data),
};
